module.exports = "<div class=\"c-checkout-suggestions c-upsell\"> <span ng-if=\"$ctrl.content && $ctrl.content.body.text.length\" ng-bind-html=$ctrl.markdown($ctrl.content.body.text)></span> <display-suggestions load-on-init=true can-load-staff=$ctrl.content.settings.load_staff></display-suggestions> </div> ";


//////////////////
// WEBPACK FOOTER
// ./frontend/storefront/app/modules/checkout/views/suggestions.html
// module id = 827
// module chunks = 0